<script lang="ts" setup>
import type { CasinoItemGame } from '~/composables/casino/interface'
import { useRuntimeConfig } from '#app'
defineProps({
  indirectBetting: {
    type: Array as () => CasinoItemGame[],
    required: true
  }
})
const emits = defineEmits(['playGameIndirect'])
function playGameIndirect(url: string | undefined): void {
  emits('playGameIndirect', url)
}
const config = useRuntimeConfig()
const domainMedialName = config.public.INDIRECT_BRAND_NAME
</script>
<template>
  <div class="casino-direct casino-indirect pb-0">
    <div class="header-casino">
      <div class="header-casino__title">Casino Tại {{ domainMedialName }}</div>
    </div>
    <div class="intermediate">
      <div
        v-for="(item, index) in indirectBetting"
        :key="index"
        :class="['item-casino', item?.class]"
        @click="playGameIndirect(item.url)"
      >
        <img class="img-casino" :src="item?.img?.thumbnail?.url" :alt="item?.title" />
        <div class="title-casino">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/casino/casino-indirect.scss';
</style>
